module.exports = __webpack_public_path__ + "static/media/salPred.ec51e843.jpg";